/**
 * VYREGISTRET — den andra och sista raden i att registrera en skärm.
 *
 *     1. En rad i SKARMAR (src/app/skarmar.ts): id, sokvag, titel, foralder, lage.
 *     2. En rad HÄR: id -> komponent.
 *
 * Ingen router att ändra, ingen meny att uppdatera, ingen bakåtknapp att koppla.
 *
 * TYPEN ÄR SPÄRREN. `Record<SkarmId, ...>` betyder att en ny SkarmId utan rad
 * här är ett kompileringsfel, inte en vit skärm i drift.
 *
 * KOMPONENTEN TAR INGA PROPS. Behöver din skärm ett id ur adressen läser du det
 * med `usePlats().params` — arbetsordern hämtar sitt work_order_id så. Behöver
 * den vem som är inloggad läser du det med `useInloggad()`. Att skicka in dem
 * som props härifrån hade gjort registret till ett ställe där varje skärms
 * beroenden också står, och då är det två ställen att ändra i stället för ett.
 */

import type { ComponentType } from 'react';
import type { SkarmId } from './skarmar';
import { AttFakturera } from '../skarmar/AttFakturera';
import { Attestera } from '../skarmar/Attestera';
import { Hem } from '../skarmar/Hem';
import { Igang } from '../skarmar/Igang';
import { Inhyrda } from '../skarmar/Inhyrda';
import { Installningar } from '../skarmar/Installningar';
import { Kalender } from '../skarmar/Kalender';
import { Kunder } from '../skarmar/Kunder';
import { Laget } from '../skarmar/Laget';
import { LagetIdag } from '../skarmar/LagetIdag';
import { Mil } from '../skarmar/Mil';
import { Moment } from '../skarmar/Moment';
import { NyFirma } from '../skarmar/NyFirma';
import { NyOrder } from '../skarmar/NyOrder';
import { Order } from '../skarmar/Order';
import { Ordrar } from '../skarmar/Ordrar';
import { Personal } from '../skarmar/Personal';
import { Prenumeration } from '../skarmar/Prenumeration';
import { Profil } from '../skarmar/Profil';
import { RaderaFirma } from '../skarmar/RaderaFirma';
import { Tid } from '../skarmar/Tid';
import { Tidny } from '../skarmar/Tidny';
import { Timpriser } from '../skarmar/Timpriser';
import { Utlagg } from '../skarmar/Utlagg';

export const VYER: Readonly<Record<SkarmId, ComponentType>> = {
  /* --- Stommen: byggda --- */
  hem: Hem,
  lag: Laget,
  kalender: Kalender,
  installningar: Installningar,
  profil: Profil,
  // Står också i världen 'ingen_firma', som ligger utanför navigeringen —
  // därför tar den inga props och frågar efter navigeringen med
  // useNavigeringOm(). Se NyFirma.tsx.
  nyfirma: NyFirma,
  igang: Igang,

  /* --- De tio skärmarna. Byt raden till din komponent när den är klar. --- */
  ordrar: Ordrar,
  ordny: NyOrder,
  order: Order,
  tidny: Tidny,
  tid: Tid,
  mil: Mil,
  utlagg: Utlagg,
  attest: Attestera,
  var: LagetIdag,
  inhyrda: Inhyrda,
  fakturera: AttFakturera,

  /* --- Firmans stamdata, bakom kugghjulet. Se blocket sist i skarmar.ts. --- */
  moment: Moment,
  kunder: Kunder,
  timpriser: Timpriser,
  personal: Personal,
  prenumeration: Prenumeration,
  // Bekräftelsevyn bakom raden "Radera firman" längst ner i Inställningar.
  raderafirma: RaderaFirma,
};
